import axios from 'axios';
const adminURL = process.env.VUE_APP_ADMIN_URL;

export default class BrokerService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getAll() {
    try {
      const res = await axios.get(`${adminURL}/brokers`, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch (e) { return { status: 'error' }; }
  }

  static async create(data) {
    try {
      const res = await axios.post(`${adminURL}/brokers/create`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch (e) { return { status: 'error' }; }
  }

  static async update(id, data) {
    try {
      const res = await axios.put(`${adminURL}/brokers/${id}`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch (e) { return { status: 'error' }; }
  }

  static async remove(id) {
    try {
      await axios.delete(`${adminURL}/brokers/${id}`, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch (e) { return { status: 'error' }; }
  }
}
